const state= {};

const getters = {};


const actions = {
    async getItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`/api/properties/versionings`, {params:params})
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async createItem({commit}, data){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`/api/properties/versionings`, data)
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async updateItem({commit}, data){
        return new Promise (( resolve, reject ) => {
            global.axios.put(`/api/properties/versionings/${data.id}`, data)
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async deleteItems({commit}, ids){
        return new Promise (( resolve, reject ) => {
            global.axios.delete(`/api/properties/versionings`, {
                data:{
                    ids: ids
                }
            }).then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },

}

const mutations = {};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
